import { Dispatch, SetStateAction } from 'react'
import { postPolicyQuote } from '../api/policyquote'
import { IChildPlanFormData } from '../contexts/ChildPlanFormDataContext'
import { IParentFormData } from '../contexts/ParentFormDataContext'
import { IPolicyQuoteRequest } from '../model/IPolicyQuoteRequest'

export async function fetchPolicyQuote(
    parentData: IParentFormData,
    childData: IChildPlanFormData[],
    setParentFormData: Dispatch<SetStateAction<IParentFormData>>,
    setChildPlanFormData: Dispatch<SetStateAction<IChildPlanFormData[]>>
) {
    let insureds: any = []
    childData.map((child: IChildPlanFormData, index) => {
        if (child.Plan.PlanCode !== '') {
            let childInfo = {
                planCode: child.Plan.PlanCode,
                organizationSchoolId: child.School.id ? child.School.id : -1,
                dob: new Date(2022, 1, 1),
                firstname: index.toString(),
            }
            insureds.push(childInfo)
        }
    })
    const quoteRequest: IPolicyQuoteRequest = {
        provstate: parentData?.Province?.id ? parentData?.Province?.id : 'ON',
        language: parentData?.Language,
        emailAddress: parentData.Email ? parentData.Email : '',
        effectivedate: parentData.StartDate ? parentData.StartDate : new Date(),
        insureds: insureds,
    }
    try {
        if (insureds.length > 0) {
            const data = await postPolicyQuote(quoteRequest)
            setParentFormData((prevFormData) => {
                const newFormData = {
                    ...prevFormData,
                    FamilyRate: data.familyrate == 'Family' ? true : false,
                    TotalPremium: data.totalPremium,
                    QuoteErrorMessages: [],
                }
                return newFormData
            })
            let newChildData = [...childData]
            childData.map((c, index) => {
                let premium = data.insureds.find(
                    (x) => x.firstname == index.toString()
                )?.insuredpremium
                if (premium !== null && premium !== undefined) {
                    newChildData[index] = {
                        ...c,
                        Plan: {
                            PlanCode: c.Plan.PlanCode,
                            Primary: c.Plan.Primary,
                            Premium: premium,
                            Index: c.Plan.Index,
                            IsValid: true,
                        },
                    }
                } else {
                    newChildData[index] = { ...c }
                }
            })
            setChildPlanFormData(newChildData)
        }
    } catch (error) {
        console.log('Policy Quote Error:', error)
    }
}
